import React, { useEffect, useRef} from 'react';
import '../styles/AboutUsPage.css';

import img3 from '../assets/aboutUs-Image/Mask group.png'
import img4 from '../assets/aboutUs-Image/Mask group (1).png'
import galleryPhoto_1 from '../assets/aboutUs-Image/galleryPhoto1.png'
import galleryPhoto_2 from '../assets/aboutUs-Image/galleryPhoto2.png'
import galleryPhoto_3 from '../assets/aboutUs-Image/galleryPhoto3.png'
import galleryPhoto_5 from '../assets/aboutUs-Image/galleryPhoto5.png'
import galleryPhoto_6 from '../assets/aboutUs-Image/galleryPhoto6.png'
import PageHeader from './PageHeader';

const allImages = [galleryPhoto_1, galleryPhoto_2, galleryPhoto_3, galleryPhoto_5, galleryPhoto_6,
  galleryPhoto_1, galleryPhoto_2, galleryPhoto_3, galleryPhoto_5, galleryPhoto_6,
  galleryPhoto_1, galleryPhoto_2, galleryPhoto_3, galleryPhoto_5, galleryPhoto_6,
  galleryPhoto_1, galleryPhoto_2, galleryPhoto_3, galleryPhoto_5, galleryPhoto_6,
  galleryPhoto_1, galleryPhoto_2, galleryPhoto_3, galleryPhoto_5, galleryPhoto_6
];

const AboutUsPage: React.FC = () => {
  
    const galleryRef = useRef<HTMLDivElement>(null);
  
    const scroll = (direction: number) => {
      if (galleryRef.current) {
        const container = galleryRef.current;
        const scrollAmount = container.offsetWidth;
  
        // Smooth scroll
        container.scrollBy({ left: direction * scrollAmount, behavior: "smooth" });
  
        // Loop logic
        setTimeout(() => {
          if (direction === 1 && container.scrollLeft >= container.scrollWidth - container.offsetWidth) {
            container.scrollLeft = 0;
          } else if (direction === -1 && container.scrollLeft === 0) {
            container.scrollLeft = container.scrollWidth;
          }
        }, 600);
      }
    };
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-us-page">
      <PageHeader heading='About Us' text='Bring on your technology challenges. At ReventLabs, we believe that complex infrastructure problems are opportunities for innovation. We tackle the toughest DevOps, cloud, and SRE challenges head-on, delivering solutions that transform how teams build, deploy, and operate at scale.'/>

      {/* About company */}
      <div className='about-company'>
        <div className='about-company-column'>
          {/* who we are */}
          <div className="about-company-text-column">
              <p className="sections-title">Who We Are</p>
              <p className="about-company-text">
                ReventLabs is a premier cloud-native services firm founded to help organizations accelerate their digital transformation journeys. 
                Our team of seasoned engineers, architects, and DevOps experts partners with clients to design, build, and manage scalable, secure, 
                and cost-effective infrastructure solutions across AWS, Google Cloud, Azure, Digital Ocean and on-premises environments.
              </p>
              <p className="about-company-text">
                With a passion for automation, best practices, and continuous improvement, ReventLabs delivers end-to-end services—from initial 
                assessment through long-term support—ensuring our clients achieve tangible business outcomes and maintain a competitive edge.
              </p>
          </div>

          {/* why company exist */}
          <div className="about-company-text-column">
              <p className="sections-title">Why ReventLabs Exists</p>
              <p className="about-company-text">
              We founded ReventLabs when we saw teams struggling to maintain brittle, manually managed environments. 
              Instead of piecemeal support, clients needed a partner who could truly embed in their workflows—co-owning 
              problems as if we were part of their engineering team.
              </p>
              <p className="about-company-text">
              Drawing on years of experience architecting multi-cloud infrastructures and large-scale SRE systems, 
              we built ReventLabs to fill that gap. Today, our mission is simple: treat infrastructure as code, automate aggressively, 
              and empower organizations to focus on innovation rather than firefighting.
            </p>
          </div>
        </div>
      </div>

      {/* Company Story */}
      <div className='company-story-section'>
      <div className='company-story'>
        <div className="company-story-text-column">
            <p className="sections-title">Our Story</p>
            <p className="about-company-text">
              Founded by a group of cloud and DevOps veterans, ReventLabs was born out of a shared belief: traditional IT 
              processes were not keeping pace with the demands of modern applications. We recognized early on that organizations 
              needed more than just advisory—they needed hands-on execution, templates that work at scale, and a partner who 
              understood the daily pressures DevOps teams face.
            </p>
            <p className="about-company-text">
            Over the years, ReventLabs has grown from a small consultancy into a multi-disciplinary team, delivering hundreds of 
              successful engagements spanning global cloud migrations, high-availability Kubernetes deployments, and fully automated 
              CI/CD pipelines. Our track record of turning complex requirements into reliable, automated solutions has earned our 
              clients' trust and driven our sustained growth.
            </p>
        </div>
        <img src={img3} alt="img" className='company-story-image'></img>
      </div>
      </div>

      {/* Mission & Vision */}
      <div className='mission-vision-section'>
        <div className='mission-vision'>
          <div className='mission-vision-card'>
          <p className="mission-vision-card-title">Our Mission</p>
          <p className="mission-vision-card-text">
            To empower organizations through innovative technology solutions that transform operations,
            enhance user experiences, and drive sustainable growth.
          </p>
          </div>
          <div className='mission-vision-card'>
          <p className="mission-vision-card-title">Our Vision</p>
          <p className="mission-vision-card-text">
            To be the leading technology partner for forward-thinking organizations, known for our technical
            excellence, impactful solutions, and exceptional client partnerships.
          </p>
          </div>
        </div>
      </div>

      {/* Core Values */}
      <div className='core-values'>
      <div className="core-values-section">
        <p className="sections-title">Our Core Values</p>
        <div className="values-container">
          <div className="value-card">
          <span className="industry-card-number-idc">01</span>
            {/* <span className="value-number">01</span> */}
            <h4 className="value-title">Craftsmanship Over Convenience</h4>
            <p className="value-description">
              We maintain a growth mindset and insist on writing clean, maintainable infrastructure code—whether 
              it's defining environments, creating configuration manifests, or orchestrating deployments.
            </p>
          </div>

          <div className="value-card">
          <span className="industry-card-number-idc">02</span>
            <h4 className="value-title">Be the Reliable Backbone</h4>
            <p className="value-description">
              Dependability is non-negotiable. We show up consistently, anticipate risks, and drive projects 
              forward even when the path isn't clear.
            </p>
          </div>

          <div className="value-card">
          <span className="industry-card-number-idc">03</span>
            <h4 className="value-title">Hustle with Humility</h4>
            <p className="value-description">
              We tackle complex challenges with determination, but never lose sight of collaboration and respect. 
              Ego has no place in problem-solving.
            </p>
          </div>

          <div className="value-card">
          <span className="industry-card-number-idc">04</span>
            <h4 className="value-title">Security by Default</h4>
            <p className="value-description">
              Every design, every automation script, and every deployment follows the principle of least privilege. 
              We embed compliance checks into our workflows so you're audit-ready from day one.
            </p>
          </div>
        </div>
      </div>
      </div>

      {/* Our Embedded "BetaPods" Model */}
      <div className='model-section-container'>
      <div className="model-section">
        <img src={img4} alt="img" className='model-section-image'></img>
        <div className='model-container'>
          <h3 className="sections-title">Our Embedded "BetaPods" Model</h3>
            <div className="model-card">
              <h4 className="value-title">Seamless Integration</h4>
              <p className="value-description">
                We assign a small, dedicated team of experts—our "BetaPods"—to work alongside your engineers.
              </p>
            </div>

            <div className="model-card">
              <h4 className="value-title">Co-Ownership of Outcomes</h4>
              <p className="value-description">
                BetaPods adopt your processes and standards, sharing responsibility for design reviews, change management, and incident response.
              </p>
            </div>

            <div className="model-card">
              <h4 className="value-title">Rapid Value Delivery</h4>
              <p className="value-description">
                By aligning directly with your sprint cycles and release cadences, BetaPods accelerate time to ROI—often delivering production-ready infrastructure in weeks, not months.
              </p>
            </div>
        </div>
      </div>
      </div>

      {/* Life at reventlabs */}
      <div className="gallery-container">
      <button className="side-button prev" onClick={() => scroll(-1)}>&#10094;</button>
      <div className="gallery" ref={galleryRef}>
        {allImages.map((img, index) => (
          <div className="gallery-item" key={index}>
            <div className="image-box">
              <img src={img} alt={`gallery-${index}`} />
            </div>
          </div>
        ))}
      </div>
      <button className="side-button next" onClick={() => scroll(1)}>&#10095;</button>
    </div>
    </div>
  );
};

export default AboutUsPage; 